export const SCRoutes = {
  resetPassword: '/reset/password/:token',
  printSettings: '/printer',
  trackingColis: '/tracking/:tracking/:code',
  deliveryColisInfo: '/info/:tracking/:code',
  requestDelivery: '/requestDelivery/:tracking/:code',
  clientDeliveryCustomerConfirmation: '/clientDelivery/clientConfirmationAction/:token',
  clientDeliveryRating: '/clientDelivery/ratings/:token',
  requestDeliveryTracking: '/clientDelivery/tracking/:token',
  clientDeliveryCustomerStripPaymentSuccess: '/clientDelivery/paymentSuccess/:token',
  clientDeliveryCustomerStripPaymentCanceled: '/clientDelivery/paymentCanceled/:token',
  eStoreRoute: '/demande/:agencySlug',
  InStoreRoute: '/agence/:agencySlug',
  HomeToStoreRoute: '/home/:agencySlug',
  HomeSendToStoreAgenciesListFromFrance: '/france',
  HomeSendToStoreAgenciesListFromMorocco: '/maroc',
  eStoreAgencySenderForm: '/information',
  dashboard: {
    home: '/dashboard',
    agencies: {
      home: '/dashboard/agencies',
      new: '/dashboard/agencies/new',
      edit: '/dashboard/agencies/edit/:id',
    },
    users: {
      home: '/dashboard/users',
      new: '/dashboard/users/new',
      edit: '/dashboard/users/edit/:id',
    },
    organization: {
      home: '/dashboard/organization',
    },
  },
};
